<!--
 * @Author: zl
 * @Date: 2022-11-10 10:45:37
 * @LastEditTime: 2022-11-15 16:49:39
 * @LastEditors: zl
 * @Description: 标签管理 --- 标签汇总 --- 标签详情页
-->
<template>
	<div class="filter-layout tag_details_layout">
		<div class="filter-box">
			<el-form label-width="150px"
					 size="small">
				<el-row>
					<el-col>
						<el-form-item label="业务板块：">
							{{ currentRow.valueName }}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="平台标签数量：">
							{{ currentRow.platformCountsName }}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="个人标签数量：">
							{{ currentRow.privateCountsName }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="标签标注记录数量：">
							{{ currentRow.typeCountsName }}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="标签标注数量：">
							{{ currentRow.objectCountsName }}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="filter-content">
			<div class="w-table-layout w-table-page">
				<div class="w-table-content">
					<vxe-table align="center"
							   auto-resize
							   border
							   :data="tableObj.tableData"
							   :loading="tableObj.loading"
							   height="100%"
							   highlight-hover-row
							   highlight-current-row
							   resizable
							   size="small"
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-column type="seq"
									title="序号"
									width="70px"></vxe-column>
						<vxe-column field="sname"
									title="标签名"
									min-width="185px"
									header-align="center"
									align="left"></vxe-column>
						<vxe-column field="groupName"
									title="标签分组"
									min-width="185px"
									header-align="center"
									align="left"></vxe-column>
						<vxe-column field="type"
									title="标签主体"
									width="150px">
							<template v-slot="{ row }">
								{{ row.type === 1 ? '平台' : '个人' }}
							</template>
						</vxe-column>
						<vxe-column field="totalCounts"
									title="热度"
									width="150px">
							<template v-slot:header>
								<span>热度</span>
								<el-tooltip placement="bottom"
											width="300"
											trigger="hover"
											effect="light"
											:content="totalCountsTip">
									<i class="el-icon-info ml5"></i>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column field="applyCounts"
									title="应用记录数"
									width="150px"
									header-align="center"
									align="right">
							<template v-slot:header>
								<span>应用记录数</span>
								<el-tooltip placement="bottom"
											width="300"
											trigger="hover"
											effect="light"
											:content="applyCountsTip">
									<i class="el-icon-info ml5"></i>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column field="createUser"
									title="创建人"
									width="150px"></vxe-column>
						<vxe-column field="createTime"
									title="创建时间"
									width="150px"></vxe-column>
						<vxe-column title="操作"
									width="150px">
							<template v-slot="{ row }">
								<el-button type="primary"
										   size="mini"
										   :disabled="row.type === 1"
										   @click="setCommon(row)">
									设为公共标签
								</el-button>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="tableObj.currentPage"
								   :page-size="tableObj.pageSize"
								   :page-sizes="[10, 20, 50, 100]"
								   layout="total, sizes, prev, pager, next, jumper"
								   :total="tableObj.total">
					</el-pagination>
				</div>
			</div>
		</div>

		<!-- 顶部返回按钮 -->
		<div class="right-btn">
			<el-button size="mini"
					   class="btn-blue"
					   @click="goBack">返回</el-button>
		</div>

		<!-- 设置公共标签弹窗 -->
		<el-dialog title="设为公共标签"
				   :visible.sync="dialog.show"
				   :close-on-click-modal="false"
				   width="800px"
				   :before-close="onCancel"
				   :destroy-on-close="true">
			<el-row>
				<el-col :span="20"
						:offset="2">
					<el-form :model="commonForm"
							 ref="commonForm"
							 label-width="100px"
							 size="small"
							 class="commonForm">
						<el-form-item label="标签名"
									  prop="sname">
							<el-input v-model="commonForm.sname"
									  disabled></el-input>
						</el-form-item>
						<el-form-item label="标签分组"
									  prop="applys"
									  :rules="requireRule">
							<el-select v-model="commonForm.applys"
									   placeholder="请选择">
								<el-option v-for="item in showList"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
			<div slot="footer"
				 class="text-center">
				<el-button @click="onCancel"
						   size="small">取消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="dialog.loading"
						   @click="onSubmit">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as API from '@/api/modules/tag_management'
import { mapState } from 'vuex'
export default {
	props: {
		// 所有数据
		allList: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			// 表格参数
			tableObj: {
				tableData: [{}],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false,
			},
			commonForm: {
				sname: '',
				applys: '',
			},
			dialog: {
				show: false,
				loading: false,
			},
			groupList: [],
			showList: [],
			requireRule: [{ required: true, message: '不能为空...' }],
			selectObj: {},
		}
	},
	created() {
		// 查询标签详情表格
		this.getTableData()
		// 获取分组
		this.getGroupList()
	},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// 查询标签详情表格
		getTableData() {
			let params = this.$utils.clone(this.queryParams, true)
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			this.tableObj.loading = true
			API.getDetail(params)
				.then((res) => {
					this.tableObj.loading = false
					let { records, total } = res.data
					records.map((x) => (x.visible = false))
					this.tableObj.tableData = records
					this.tableObj.total = parseInt(total)
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 获取分组
		getGroupList() {
			API.selectGroupData({
				sname: '',
			}).then((res) => {
				this.groupList = res.data.records
			})
		},

		/**
		 * @description: 表格相关
		 */

		// 表格 每页条数切换
		handleSizeChange(pageSize) {
			this.tableObj.pageSize = pageSize
			this.getTableData()
		},

		// 表格 页码切换
		handleCurrentChange(currentPage) {
			this.tableObj.currentPage = currentPage
			this.getTableData()
		},

		// 设置公共标签
		setCommon(row) {
			this.dialog.show = true
			this.commonForm.sname = row.sname
			this.selectObj = this.$utils.clone(row, true)
			this.showList = this.groupList.filter((x) =>
				x.applys.includes(this.currentRow.value)
			)
		},

		/**
		 * @description: 弹窗相关
		 */

		// 取消按钮
		onCancel() {
			this.$refs.commonForm.resetFields()
			this.selectObj = {}
			this.dialog.loading = false
			this.dialog.show = false
		},

		// 确定按钮
		onSubmit() {
			this.$refs.commonForm.validate((valid) => {
				if (valid) {
					let params = this.$utils.clone(this.commonForm, true)
					params.groupId = params.applys
					params.createUser = this.userInfo.sname
					params.createUserid = this.userInfo.id
					params.id = this.selectObj.id
					params.type = this.selectObj.type
					params.applys = this.selectObj.applys
					this.dialog.loading = true
					API.setCommonTag(params)
						.then((res) => {
							if (res.operationCode === 1) {
								this.$message.success('设置成功！')
								this.onCancel()
								// 重载页面
								this.getTableData()
							} else {
								this.$message.warning(res.msg)
							}
							this.dialog.loading = false
						})
						.catch(() => {
							this.dialog.loading = false
						})
					return
				}
				this.$message.error('请完善表单！')
			})
		},

		/**
		 * @description: 返回上一层
		 */

		// 返回
		goBack() {
			this.$router.push({
				path: '/tag-management',
			})
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		// 路由参数
		queryParams() {
			return this.$route.query
		},

		// 当前数据行
		currentRow() {
			let _item = this.allList.find(
				(x) => x.id === this.queryParams.rowId
			)
			if (_item) {
				return _item
			}
			return {}
		},

		// 应用记录数提示语
		applyCountsTip() {
			let msg =
				'这个标签被应用的记录的数量(不同的用户，为同一个记录打了同一个标签，不重复计算)'
			return msg
		},

		// 热度提示语
		totalCountsTip() {
			let msg =
				'这个标签被应用的总次数(不同的用户，为同一个记录打了同一个标签，重复计算)'
			return msg
		},
	},
}
</script>

<style scoped lang="less">
.tag_details_layout {
	padding: 0 !important;
	/deep/ .el-form-item__label {
		padding-right: 0;
	}
	.filter-box {
		border-bottom: none;
	}
}
.tips-row {
	padding-bottom: 10px;
	.tips-text {
		font-weight: 700;
		font-size: 16px;
		color: #409eff;
	}
}
.right-btn {
	position: absolute;
	top: 6px;
	right: 20px;
}
.commonForm {
	/deep/ .el-form-item__label {
		padding-right: 15px;
	}
}
</style>
